import React, { useEffect, useRef } from "react";
import TableAction from "./TableAction";
import Indentification from "../Indentification";
import { classNames } from "../../../helpers/classNames";
import Image from "../Image";
import Select from "../../form/select/Select";
import Switch from "../../form/Switch";
import Input from "../../form/Input";
import Textarea from "../../form/Textarea";
import { initialsValue } from "../../../helpers";
import Checkbox from "../../form/Checkbox";
import { Tooltip } from "react-tooltip";
import CompressImage from "../CompressedImage";

const Td = ({
  data,
  statusLabel,
  statusType,
  align,
  functions = () => {},
  actionData,
  checkboxChecked,
  onCheckboxChange,
  tableActionDropdownContainer,
  onClick = () => {},
}) => {
  const status = {
    success: "bg-green-100 text-green-600/80 border border-green-200/50",
    danger: "bg-rose-100 text-rose-600/80 border border-rose-200/50",
    warning: "bg-amber-100 text-amber-600/80 border border-amber-200/50",
    info: "bg-sky-100 text-sky-600/80 border border-skysky-200/50",
    "": "bg-slate-100 text-slate-600/80 border border-slate-200/50",
  };

  return (
    <>
      <td
        className={classNames(
          "py-3 px-2 max-w-[240px] font-normal text-primaryText",
          data.cellClass,
          data.align === "left" ? "text-left" : data.align === "right" ? "text-right" : data.align === "center" ? "text-center" : "",
          "last:right-0"
        )}
      >
        {data.type === "text" && <div className="text-[13px]   text-sidebar">{data.data}</div>}
        {data.type === "user" && (
          <>
            {data?.isTooltip ? (
              <div className="relative inline-flex items-center" data-tooltip-id={`userTooltip${data?._id}`} data-tooltip-place="right">
                <Indentification initial={initialsValue(data?.data)} image={data?.image} alt={data?.data} fill={true} className={""} size={"md"} />
                <div className="text-md mx-2" onClick={(e) => onClick(e?.view?.location)}>
                  {data?.data}
                </div>
                {data?.isTooltip && (
                  <Tooltip
                    id={`userTooltip${data?._id}`}
                    className="text-slate-500 !text-[13px] !bg-slate-950 !bg-opacity-100 z-100"
                    render={() => data?.toolTipData}
                  />
                )}
              </div>
            ) : (
              <div className="relative flex items-center">
                <Indentification initial={initialsValue(data?.data)} image={data?.image} alt={data.data} fill={true} className={""} size={"md"} />
                <div className="text-md mx-2" onClick={(e) => onClick(e?.view?.location)}>
                  {data.data}
                </div>
              </div>
            )}
          </>
        )}
        {data.type === "data" && <>{data?.data}</>}
        {data.type === "image" && (
          <div className="flex space-x-[-8px]">
            {Array.isArray(data.image) ? (
              data.image.map((item, index) => (
                <div key={index} className="w-8 h-8 overflow-hidden rounded-full border-2 border-white">
                  <Image src={item?.url} alt={`img-${index}`} effect="blur" />
                </div>
              ))
            ) : (
              <div className="w-8 h-8 overflow-hidden rounded-full">
                <Image src={data.image} alt="img" effect="blur" />
              </div>
            )}
          </div>
        )}
        {data.type === "imageWithText" && (
          <div className="flex items-center space-x-2">
            <div className="flex -space-x-2">
              {Array.isArray(data.image) ? (
                data.image.map((item, index) => (
                  <div key={index} className="w-8 h-8 overflow-hidden rounded-full border-2 border-white">
                    <Image src={item?.url} alt={`img-${index}`} effect="blur" />
                  </div>
                ))
              ) : (
                <div className="w-8 h-8 overflow-hidden rounded-full border-2 border-white">
                  <Image src={data.image} alt="img" effect="blur" />
                </div>
              )}
            </div>
            {data?.data && <span>{data.data}</span>}
          </div>
        )}
        {data.type === "scannerImage" && (
          <div className="flex space-x-[-8px]">
            {
              <div className="w-8 h-8 overflow-hidden rounded-md">
                <Image src={data.image} alt="img" effect="blur" />
              </div>
            }
          </div>
        )}
        {data?.type === "text-tooltip" && (
          <div className="relative inline-flex items-center" data-tooltip-id={`statusTooltip${data?._id}`} data-tooltip-place="right">
            <div className={"text-[13px]   text-slate-600 mx-2 "}>{data?.data}</div>
            {data?.isTooltip && (
              <Tooltip
                id={`statusTooltip${data?._id}`}
                className="text-slate-500 !text-[13px] !bg-slate-950 !bg-opacity-100 z-100"
                render={() => data?.toolTipData}
              />
            )}
          </div>
        )}
        {/* {data.type === "status" && (
          <div
            className={classNames(
              "flex items-center",
              data.align === "left"
                ? "justify-start"
                : data.align === "right"
                ? "justify-end"
                : data.align === "center"
                ? "justify-center"
                : ""
            )}
          >
            <Select
              xPlacement={"bottomLeft"}
              dropdownclassName={"!min-w-[120px]"}
              dropdownButtonclassName={
                "!border-transparent hover:!border-org-border !h-8 !w-auto group/select !  !p-0 !pr-6 !border-none"
              }
              buttonArrowIconClasses={
                "opacity-0 group-hover/select:opacity-100"
              }
              selectedValue={
                data.dataSelected
                  ? data.dataSelected
                  : { _id: -1, name: "Select" }
              }
              dropdownData={data.data}
              onChange={(val) => (data.onChange ? data.onChange(val) : "")}
            />
          </div>
        )} */}
        {data.type === "status" && (
          <div
            onClick={(e) => functions && functions({ data: data?.statusLabel, event: e })}
            className={classNames(
              "flex items-center cursor-pointer capitalize",
              align === "left" ? "justify-start" : align === "right" ? "justify-end" : align === "center" ? "justify-center" : ""
            )}
          >
            <div className={"text-[11px]   leading-tight rounded py-1 px-2 " + status[data.statusType]}>{data?.statusLabel}</div>
          </div>
        )}
        {data.type === "action" && (
          <div
            className={classNames(
              "flex items-center",
              align === "left" ? "justify-start" : align === "right" ? "justify-end" : align === "center" ? "justify-center" : ""
            )}
          >
            <TableAction data={data.actionData} xPlacement={"right"} dropdownContainer={tableActionDropdownContainer} />
          </div>
        )}
        {data.type === "select" && (
          <div
            className={classNames(
              "flex items-center",
              data.align === "left" ? "justify-start" : data.align === "right" ? "justify-end" : data.align === "center" ? "justify-center" : ""
            )}
          >
            <Select
              xPlacement={"bottomLeft"}
              dropdownclassName={"!w-full !min-w-[160px]"}
              dropdownButtonclassName={"!border-transparent hover:!border-org-border !h-8 !w-auto group/select ! "}
              buttonArrowIconClasses={"opacity-0 group-hover/select:opacity-100"}
              selectedValue={data.dataSelected ? data.dataSelected : { _id: -1, name: "Select" }}
              dropdownData={data.data}
            />
          </div>
        )}
        {data.type === "input" && (
          <div
            className={classNames(
              "flex items-center",
              data.align === "left" ? "justify-start" : data.align === "right" ? "justify-end" : data.align === "center" ? "justify-center" : ""
            )}
          >
            <Input
              divClasses={"!w-auto"}
              inputType={"text"}
              value={data.data}
              inputClasses={"!h-8 !w-auto !border-transparent hover:!border-org-border focus:!border-org-border"}
            />
          </div>
        )}
        {data.type === "textarea" && (
          <div
            className={classNames(
              "flex items-center",
              data.align === "left" ? "justify-start" : data.align === "right" ? "justify-end" : data.align === "center" ? "justify-center" : ""
            )}
          >
            <Textarea />
          </div>
        )}
        {data.type === "switch" && (
          <div
            className={classNames(
              "flex items-center",
              data.align === "left" ? "justify-start" : data.align === "right" ? "justify-end" : data.align === "center" ? "justify-center" : ""
            )}
          >
            <Switch checked={data.data} onChange={data.setData} />
          </div>
        )}
        {data.type === "avatar" && (
          <div className={classNames("relative w-16 h-16 min-w-[32px] overflow-hidden rounded-md bg-magenta-100")}>
            <Image src={data.image} alt={""} layout="fill" objectFit="cover" />
          </div>
        )}
        {data?.type === "checkbox" && <Checkbox checked={checkboxChecked} onChange={onCheckboxChange} />}
      </td>
    </>
  );
};

export default Td;
